import React from 'react';
import { LayoutDashboard, Briefcase, ClipboardList, BarChart3, Shield, Settings as SettingsIcon } from 'lucide-react';
import { PageKey } from '../types';

const NAV_ITEMS: { key: PageKey; label: string; icon: React.ElementType }[] = [
  { key: 'dashboard', label: 'Dashboard',     icon: LayoutDashboard },
  { key: 'analysis',  label: 'Trading Intelligence', icon: BarChart3 },
  { key: 'positions', label: 'Portfolio',     icon: Briefcase },
  { key: 'orders',    label: 'Orders',        icon: ClipboardList },
  { key: 'risk',      label: 'Risk Monitor',  icon: Shield },
  { key: 'settings',  label: 'Settings',      icon: SettingsIcon },
];

export function Navigation({ activePage, setActivePage }:{
  activePage: PageKey;
  setActivePage: (p: PageKey) => void;
}) {
  return (
    <div style={{ backgroundColor: '#1e293b', padding: 16, borderRadius: 8, border: '1px solid #334155' }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: 14, fontWeight: 600, color: '#94a3b8' }}>NAVIGATION</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {NAV_ITEMS.map(item => {
          const Icon = item.icon;
          const active = activePage === item.key;
          return (
            <div
              key={item.key}
              onClick={() => setActivePage(item.key)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '8px 12px',
                borderRadius: 6,
                backgroundColor: active ? '#3b82f6' : 'transparent',
                color: active ? 'white' : '#94a3b8',
                cursor: 'pointer',
                fontSize: 13,
                fontWeight: active ? 500 : 400,
                transition: 'all 0.2s'
              }}
            >
              <Icon size={16} />
              <span>{item.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
